import React, { useState, useRef, useEffect } from 'react';
import './SaveDropdown.css';

/**
 * Bouton split "Sauvegarder" avec dropdown pour planifier
 */
function SaveDropdown({ onSave, onSchedule, disabled = false }) {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    // Fermer le dropdown si on clique ailleurs
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen]);

    const handleSaveClick = () => {
        if (!disabled) {
            onSave();
            setIsOpen(false);
        }
    };

    const handleScheduleClick = () => {
        if (!disabled) {
            onSchedule();
            setIsOpen(false);
        }
    };

    const toggleDropdown = (e) => {
        e.stopPropagation();
        if (!disabled) {
            setIsOpen(!isOpen);
        }
    };

    return (
        <div className={`save-dropdown ${disabled ? 'disabled' : ''}`} ref={dropdownRef}>
            <button
                className="save-dropdown-main btn btn-success"
                onClick={handleSaveClick}
                disabled={disabled}
                title="Sauvegarder maintenant"
            >
                💾 Sauvegarder
            </button>
            <button
                className="save-dropdown-toggle btn btn-success"
                onClick={toggleDropdown}
                disabled={disabled}
                title="Plus d'options"
            >
                <svg
                    width="12"
                    height="12"
                    fill="currentColor"
                    viewBox="0 0 16 16"
                    style={{ transform: isOpen ? 'rotate(180deg)' : 'none', transition: 'transform 0.2s' }}
                >
                    <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                </svg>
            </button>

            {isOpen && (
                <div className="save-dropdown-menu">
                    <button
                        className="save-dropdown-item"
                        onClick={handleSaveClick}
                    >
                        <span className="dropdown-icon">💾</span>
                        <span>Sauvegarder maintenant</span>
                    </button>
                    {onSchedule && (
                        <>
                            <div className="save-dropdown-divider"></div>
                            <button
                                className="save-dropdown-item"
                                onClick={handleScheduleClick}
                            >
                                <span className="dropdown-icon">⏰</span>
                                <span>Planifier une modification</span>
                            </button>
                        </>
                    )}
                </div>
            )}
        </div>
    );
}

export default SaveDropdown;
